module.exports = __webpack_public_path__ + "img/hotels-canada-2.2f8eaedb.png";